<div class="location-map">
  <div #mapContainer class="map-container"></div>
</div>
